export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}performance-review/performance-review`;
    const url = `${baseUrl}/:id`;
    return $resource(url, null, {
        indexManage: {
            method: 'GET',
            url: `${baseUrl}/index-manage`,
            isArray: true
        },
        update: {
            method: 'PUT',
            url
        },
        publicView: {
            method: 'GET',
            url: `${baseUrl}/:guid`
        },
        publicUpdate: {
            method: 'PUT',
            url: `${baseUrl}/:guid`
        },
        question: {
            method: 'GET',
            url: `${baseUrl}/:guid/question`,
            isArray: true
        },
        setAnswers: {
            method: 'POST',
            url: `${baseUrl}/:guid/set-answers`
        },
        setResults: {
            method: 'POST',
            url: `${baseUrl}/:guid/set-results`,
            isArray: true
        },
        setGoals: {
            method: 'POST',
            url: `${baseUrl}/:guid/set-goals`,
            isArray: true
        },
        setTrainingNeeds: {
            method: 'POST',
            url: `${baseUrl}/:guid/set-training-needs`,
            isArray: true
        },
        trainingNeeds: {
            method: 'GET',
            url: `${baseUrl}/training-need`,
            isArray: true
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Review/index.js